import PropTypes from 'prop-types';
import LabelTextInline from "../../utils/LabelTextInline/LabelTextInline";
import { isEmpty } from 'lodash';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const ServiceAreas = _ref => {
  let {
    className = '',
    service_areas = [],
    intlProvider = {}
  } = _ref;
  const nationalServiceArea = service_areas.find(sA => sA.service_area_type === 'national');
  const statesServiceAreas = service_areas.filter(sA => sA.service_area_type === 'state').map(sA => sA.name);
  return /*#__PURE__*/_jsx("div", {
    className: "".concat(className, " text-brand-blue font-regular-font text-sm"),
    children: /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx("h4", {
        className: "mb-1 font-heavy-font",
        children: !isEmpty(intlProvider) ? intlProvider.formatMessage({
          id: "J6BEWS",
          description: "service-areas",
          defaultMessage: "Service Areas"
        }) : "Service Areas"
      }), nationalServiceArea && /*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx(LabelTextInline, {
          className: "mb-1 flex",
          label: !isEmpty(intlProvider) ? intlProvider.formatMessage({
            id: "SqRb6P",
            description: "national",
            defaultMessage: "National"
          }) : 'National',
          content: !isEmpty(intlProvider) ? intlProvider.formatMessage({
            id: "VTO8h4",
            description: "content-text",
            defaultMessage: "This program serves the entire country"
          }) : 'This program serves the entire country'
        })
      }), !nationalServiceArea && /*#__PURE__*/_jsx("div", {
        children: statesServiceAreas.length > 0 && /*#__PURE__*/_jsx(LabelTextInline, {
          className: "mb-1 flex",
          label: !isEmpty(intlProvider) ? intlProvider.formatMessage({
            id: "XW82Wp",
            description: "states",
            defaultMessage: "States"
          }) : 'States',
          content: statesServiceAreas
        })
      })]
    })
  });
};
ServiceAreas.propTypes = {
  className: PropTypes.string,
  /** Array of Service Areas objects. It can contain National Service area if the program serves the entire country, States or Cities */
  service_areas: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    program: PropTypes.shape({
      id: PropTypes.string
    }),
    service_area_type: PropTypes.string,
    state_abbreviation: PropTypes.string
  })),
  intlProvider: PropTypes.shape({
    locale: PropTypes.string,
    messages: PropTypes.object,
    formatMessage: PropTypes.func
  })
};
export default ServiceAreas;
//# sourceMappingURL=ServiceAreas.js.map